import { render, staticRenderFns } from "./formtable.vue?vue&type=template&id=0ae90d7a&scoped=true&lang=html"
import script from "./formtable.vue?vue&type=script&lang=js"
export * from "./formtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae90d7a",
  null
  
)

export default component.exports